(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  (function () {
    if (window.__t4sCollectionBannerFilterSync) return;
    window.__t4sCollectionBannerFilterSync = true;

    function hasFilterQuery() {
      var hasFilter = false;
      new URLSearchParams(window.location.search).forEach(function (value, key) {
        if (key.indexOf('filter.') === 0 || key === 'sort_by') {
          hasFilter = true;
        }
      });
      return hasFilter;
    }

    function syncCollectionBanners() {
      document.querySelectorAll('[data-ntajax-options][data-has-filters]').forEach(function (container) {
        var section = container.closest('.shopify-section') || document;
        var hasActiveFilters = hasFilterQuery() || !!container.querySelector('.t4s-active-filters__remove-filter');

        section.querySelectorAll('[data-hide-on-filter]').forEach(function (banner) {
          banner.style.display = hasActiveFilters ? 'none' : '';
        });
      });
    }

    var syncTimer;
    function requestSync() {
      window.clearTimeout(syncTimer);
      syncTimer = window.setTimeout(syncCollectionBanners, 50);
    }

    document.addEventListener('DOMContentLoaded', syncCollectionBanners);
    window.addEventListener('popstate', requestSync);
    document.addEventListener('click', function (event) {
      if (event.target.closest('[data-filter-links] a, [data-sidebar-links] a, .t4s-active-filters a, [data-filter-sortby] a, [data-sortby-item]')) {
        requestSync();
      }
    });

    function observeChanges() {
      if (!document.body || !window.MutationObserver) return;
      new MutationObserver(requestSync).observe(document.body, {
        childList: true,
        subtree: true
      });
    }

    if (document.body) {
      observeChanges();
    } else {
      document.addEventListener('DOMContentLoaded', observeChanges);
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
